<template>
  <div id="overlay">
    <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
      <div class="confirm">
        <div class="confirm_header">
          確認
        </div>
        <div class='confirmDialog'>
        <!-- 初期表示 -->
          <div class="dialogContainer" v-if="processing.result === ''">
            <div class="mb-3 confirm_table">
              <div class="icon_confirm" />
              <div class="confirm_wording">{{ initialMessage }}</div>
            </div>
            <div class="btnContainer">
              <div>
                <button
                  class="bluebackbutton col-btn-size"
                  @click="clickEvent"
                  :disabled="Boolean(processing.btnDisabled)">
                  {{ doing }}</button>
              </div>
              <div>
                <button class="mypagebackbutton col-btn-size" @click="closeEvent" >{{ notDoing }}</button>
              </div>
            </div>
          </div>
        <!-- 処理後の表示 -->
          <div class="dialogContainer" v-if="processing.result !== ''">
            <div class="mb-3 confirm_table">
              <div class="confirm_wording">{{ processing.resultText }}</div>
            </div>
            <div class="btnContainer">
              <div>
                <button class="mypagebackbutton" :class="{ 'col-md-btn-size': close,'col-btn-size': !close }" @click="closeEvent" >{{ close ? close : '閉じる'}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    props: {
        // 処理結果
        processing: {
            type: Object
        },
        // 初期表示のメッセージ
        initialMessage: {
            type: String,
            required: true
        },
        // 実行ボタン名
        doing: {
            type: String,
            required: true
        },
        // 不実行ボタン名
        notDoing: {
            type: String,
            required: true
        },
        // 閉じるボタン名（必須ではない）
        close: {
            type: String,
            required: false
        },
    },
    methods: {
        /** ----------------------------------------------
         * todoボタンのイベント
         * ---------------------------------------------- */
        clickEvent (){
            this.$emit('from-Dialog');
        },
        /** ----------------------------------------------
         * 閉じるボタンのイベント
         * ---------------------------------------------- */
        closeEvent () {
            this.$emit('closeBtn');
        }
    }
}

</script>

<style scoped>

.confirm {
    width: 600px;
    margin: 0 20px 0 20px;
}

.confirm_wording {
    display: table-cell;
    vertical-align: middle;
}

.confirm_table {
    display: table;
}

.confirmDialog{
    background: #ffffff;
    padding: 30px;
}

.dialogContainer{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.btnContainer{
    display: flex;
    justify-content: space-around;
}

.col-btn-size{
    width: 90px;
    word-break: keep-all;
    margin: 1rem;
}

.col-md-btn-size {
    width: 200px;
}

.icon_confirm {
    background-size: 40px;
    height: 40px;
    width: 40px;
    float: left;
    margin: 5px;
}
@media screen and (max-width: 896px) {
    .confirmDialog{
        width: 90%;
        word-break: break-all;
        margin-left: auto;
        margin-right: auto;
    }

    .confirm_header {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
    }

    .confirm {
      width: 100%;
    }
}

</style>

